import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgQq({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2a7 7 0 016.998 6.848C20.333 12.283 21 15.667 21 19c-.667 0-1.447-.31-2.342-.928a5.301 5.301 0 01-1.242 1.973c.857.18 1.512.91 1.578 1.806L19 22H5a2 2 0 011.584-1.957 5.28 5.28 0 01-1.242-1.97C4.447 18.69 3.667 19 3 19c0-3.333.667-6.717 2.002-10.152A7 7 0 0112 2zm-5.444 9.1l-.305-.047C5.417 13.297 5 14.946 5 16c.667-.667 1.333-1.471 2-2.414V16c0 2.505 1.942 4 5 4s5-1.495 5-4v-2.414c.667.943 1.333 1.747 2 2.414 0-1.054-.417-2.703-1.25-4.947l-.307.046c-2.466.362-4.96.477-7.443.344V14H8v-2.717a37.256 37.256 0 01-1.444-.184zM12 4a5 5 0 00-5 5v.143c3.317.472 6.684.471 10.001 0L17 9a5 5 0 00-5-5z"
        fill={color}
      />
    </svg>
  )
}

export default SvgQq
